var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseS3FileList',{staticClass:"my-5",attrs:{"file-category":"company","list-endpoint":"vendorStandard.getFiles","parent-id":_vm.resource.id,"table-class":"shadow-sm"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }